import React from 'react'
import { Header, tutorialsHooks } from '.'
import { AssessmentStyles, ButtonStyles, PreformAssessmentStepsStyles, PreformAssessmentStyles, PreformAssessmentTableStyles } from './Style'
import { Button, SvgIcon } from '@mui/material'
import { ReactComponent as HeadphonesIcon } from 'assets/icons/Headphones.svg';
import { ReactComponent as MicIcon } from 'assets/icons/Mic.svg';
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { ReactComponent as ActiveAssessmentsIcon } from 'assets/icons/ActiveAssessments.svg';
import { ReactComponent as UploadFileIcon } from 'assets/icons/UploadFile.svg';
import { useNavigate } from 'react-router-dom';
import { Mic } from 'assets'
import { Book } from 'assets'
import { Img } from 'styles/GlobalStyle';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const Assessments = () => {
    const assessmentItems = tutorialsHooks.useAssessmentItems()
    const navigate = useNavigate()

    const title = "ביצוע אבחונים"
    const subTitle = "ככה זה עובד:"

    return (
        <AssessmentStyles>
            <Header title={title} subTitle={subTitle} />
            <div className='title'>{"שימו לב"}</div>
            <div className='content assessment-content'>
                {assessmentItems.map((item) => {
                    const { title } = item

                    return (
                        <div>
                            {title && <div className='title'>{title}</div>}
                            <div className='general-item'>
                                {item.type == "preformAssessment" &&
                                    <PreformAssessmentStyles>
                                        <div className='section'>
                                            <div className='assessment-tutorials'>
                                                <div className='preform-tutorials'>
                                                    {"כשמבצעים אבחון עדיף לשבת עם רמקול ואוזניות"}
                                                </div>
                                                <a className='preform-tutorials-link'>
                                                    <SvgIcon fontSize="small" component={GoIcon} inheritViewBox />
                                                    {"הדרכה להקצאת אבחונים"}
                                                </a>
                                            </div>
                                            <div className='assessment-actions'>
                                                <Button variant='contained' color="lightSecondary">
                                                    <SvgIcon fontSize="small" component={MicIcon} inheritViewBox />
                                                </Button>
                                                <Button variant='contained' color="lightSecondary">
                                                    <SvgIcon fontSize="small" component={HeadphonesIcon} inheritViewBox />
                                                </Button>
                                            </div>
                                        </div>
                                    </PreformAssessmentStyles>
                                }
                                {
                                    item.type == "preformAssessmentTable" &&
                                    <PreformAssessmentTableStyles>
                                        <div className='section'>
                                            <div className='item-button'>
                                                <ButtonStyles variant='contained' color="dark">
                                                    <SvgIcon sx={{ fontSize: 14 }} component={ActiveAssessmentsIcon} inheritViewBox />
                                                    {"אבחונים פעילים"}
                                                </ButtonStyles>
                                            </div>
                                            <div className='item-card'>
                                                <div className='table-row'>
                                                    <div className='table-col blurred'>תמר דינר</div>
                                                    <div className='table-col blurred'>החמודה</div>
                                                    <div className='table-col blurred'>והיקרה</div>
                                                    <div className='table-col assessment-status'>{"לא בוצע"}</div>
                                                    <div className='table-col blurred'>4</div>
                                                    <div className='assessment-actions'>
                                                        <div>
                                                            <div className='row-action'>
                                                                <SvgIcon component={GoIcon} inheritViewBox />
                                                            </div>
                                                            <div className='wrap-tooltip'>
                                                                <div className='tooltip'>
                                                                    {"מעבר לביצוע האבחון בתוך המערכת"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row-action'>
                                                            <SvgIcon component={UploadFileIcon} inheritViewBox />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </PreformAssessmentTableStyles>
                                }
                                {
                                    item.type == "preformAssessmentSteps" &&
                                    <PreformAssessmentStepsStyles>
                                        <div className='section'>
                                            <div className='preform-steps'>
                                                <div className='step-card'>
                                                    {"מתחילים בלחיצה על כפתור התחל"}
                                                    <div className='record-actions'>
                                                        <div className='mic-icon'>
                                                            <Img src={Mic} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='step-card'>
                                                    {"חכו שהספירה לאחור תסתיים ותתחילו לקרוא"}
                                                    <div className='backdrop-numbers'>
                                                        <div className='backdrop-1'>1</div>
                                                        <div className='backdrop-2'>2</div>
                                                        <div className='backdrop-3'>3</div>
                                                    </div>
                                                </div>
                                                <div className='step-card'>
                                                    {"לחצו על עמודי הספר או על החיצים"}
                                                    <div className='wrap-assessment-in-book'>
                                                        <ChevronRight />
                                                        <div className='assessment-in-book'>
                                                            <Img src={Book} />
                                                        </div>
                                                        <ChevronLeft />
                                                    </div>
                                                </div>
                                                <div className='step-card'>
                                                    {"כשמסיימים את כל הכרטיסים לוחצים על “סיימתי”"}
                                                    <div className='record-actions'>
                                                        {"סיימתי"}
                                                    </div>
                                                </div>
                                                <div className='step-card'>
                                                    {'לוחצים על כפתור "המשך" לעבור לשלב הבא או "סיום"'}
                                                    <div className='record-actions'>
                                                        {"המשך"}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='preform-footer'>
                                                <div>
                                                    {" כמה דקות והאבחון יהיה מוכן באזור ה"}
                                                </div>
                                                <div className='go-report' onClick={() => navigate(app.assessments)}>
                                                    {"דוחות"}
                                                </div>
                                            </div> */}
                                        </div>
                                    </PreformAssessmentStepsStyles>
                                }
                            </div>
                        </div>
                    )
                })}
            </div>
        </AssessmentStyles>
    )
}

export default Assessments